import { Modal } from './Modal'
import { Button } from './Button'

interface Props {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title?: string
  description?: string
  confirmLabel?: string
  variant?: 'primary' | 'danger'
  loading?: boolean
}

export function ConfirmDialog({
  open, onClose, onConfirm,
  title = 'Confirmar', description, confirmLabel = 'Confirmar', variant = 'primary', loading,
}: Props) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      description={description}
      size="sm"
      footer={
        <>
          {/* type="button" evita submeter um <form> ambiente (o Modal não usa portal,
              então os botões ficam dentro do form da página que abriu o diálogo). */}
          <Button type="button" variant="ghost" onClick={onClose} disabled={loading}>Cancelar</Button>
          <Button type="button" variant={variant} onClick={onConfirm} loading={loading}>{confirmLabel}</Button>
        </>
      }
    >
      <div className="text-sm text-gray-600">{description}</div>
    </Modal>
  )
}
